var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeat1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85,
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.1603 51.8389H28.8397L27.1077 56.3864C30.9139 57.3978 35.0517 58.775 39.4547 60.639C44.0241 62.5734 48.725 64.5632 56.2262 65.1403L51.1603 51.8389Z",
    fill: "#FE2C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.117 35.971L40.0001 22.5361L35.1865 35.1746C38.4636 36.2008 41.7936 36.4686 45.117 35.971Z",
    fill: "#FE2C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5145 39.5654L30.625 47.1521H49.375L46.8177 40.4375C45.2369 40.7357 43.5767 40.9082 41.8467 40.9084C39.2163 40.9086 36.4266 40.5117 33.5145 39.5654Z",
    fill: "#FE2C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5781 21.0938C19.5198 21.0938 21.0938 19.5198 21.0938 17.5781C21.0938 15.6365 19.5198 14.0625 17.5781 14.0625C15.6365 14.0625 14.0625 15.6365 14.0625 17.5781C14.0625 19.5198 15.6365 21.0938 17.5781 21.0938Z",
    fill: "#FE2C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4297 20.5703V0H0V35.7709C1.91781 34.9072 4.64516 33.8494 7.95984 33.0275C15.7725 31.0905 23.6005 31.2941 30.7723 33.5947L37.0227 17.1836H42.9772L49.69 34.8088C51.5675 34.1344 53.4322 33.2227 55.2661 32.0773C62.4094 27.6159 70.8853 25.2578 79.7775 25.2578H80V20.5703H59.4297ZM17.5781 25.7812C13.0548 25.7812 9.375 22.1014 9.375 17.5781C9.375 13.0548 13.0548 9.375 17.5781 9.375C22.1014 9.375 25.7812 13.0548 25.7812 17.5781C25.7812 22.1014 22.1014 25.7812 17.5781 25.7812Z",
    fill: "#FE2C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7493 36.0533C55.9253 37.1925 53.7759 38.3116 51.3579 39.188L61.3056 65.3067H80.0001V29.9453H79.7776C71.7645 29.9453 64.1471 32.0573 57.7493 36.0533Z",
    fill: "#FE2C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1172 15.8829H78.627L64.1172 1.37305V15.8829Z",
    fill: "#FE2C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7248 69.9944C49.5288 69.9944 43.2058 67.3178 37.6273 64.9563C33.2506 63.1035 29.1617 61.761 25.4295 60.793L22.5 68.4849L18.1195 66.8164L20.8142 59.7413C16.2577 58.8485 12.3953 58.5252 9.40547 58.4606C4.88687 58.363 1.64625 58.8214 0 59.1342V80.0002H80V69.9944H60.7248Z",
    fill: "#FE2C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.24641 53.769C12.6806 53.829 17.1803 54.2029 22.5052 55.301L29.103 37.9776C22.8363 35.9993 16.1684 35.8494 9.24203 37.5393C4.70687 38.6457 1.35641 40.2663 0 40.9861V54.3724C2.00406 54.0438 5.145 53.6969 9.24641 53.769Z",
    fill: "#FE2C55"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeat1);
export default __webpack_public_path__ + "static/media/feat1.b042a77df697ad75c57b2763a0e949a9.svg";
export { ForwardRef as ReactComponent };